import type {Components, Theme} from '@mui/material/styles';

export const dialogOverrides: Components<Theme>['MuiDialog'] = {
    defaultProps: {
        PaperProps: {
            elevation: 0,
        },
    },
};

export const dialogTitleOverrides: Components<Theme>['MuiDialogTitle'] = {
    styleOverrides: {
        root: {
            paddingTop: 24,
            fontWeight: 600
        },
    },
};

export const dialogContentTextOverrides: Components<Theme>['MuiDialogContentText'] = {
    styleOverrides: {
        root: ({theme}) => ({
            color: theme.palette.text.primary,
        }),
    },
};
